import { createSlice } from '@reduxjs/toolkit';

type AuthDataType = {
  user: any;
  loginData: object;
};

const initialState: AuthDataType = {
  user: null,
  loginData: {
    email: 'user@example.com',
    password: 'string',
  },
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserData(state, action) {
      const { payload } = action;
      state.user = payload;
    },
    setLoginData(state, action) {
      const { payload } = action;
      state.loginData = payload;
    },
    clearUser(state) {
      state.user = initialState.user;
    },
  },
});

export const { setUserData, clearUser, setLoginData } = authSlice.actions;
export default authSlice.reducer;
